const initialState = {
  data: [],
};
  
const udzialyKontaAktReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_UDZIALY_KONTA_AKT':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default udzialyKontaAktReducer;